import LandingNav from "../../landing-page/components/LandingNav";
import Footer from "../../landing-page/components/Footer";
import { footerNavigation } from "../../landing-page/contentSections";

export const TermsPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <LandingNav />
      <main className="flex-grow pt-32 pb-16 px-6 lg:px-8 max-w-4xl mx-auto w-full">
        <h1 className="text-4xl font-bold mb-8">Terms of Use</h1>
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Gedoba, you agree to be bound by these Terms of Use and all
              applicable laws and regulations.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">2. Use License</h2>
            <p>
              Permission is granted to temporarily download one copy of the materials on Gedoba
              for personal, non-commercial transitory viewing only.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">3. Disclaimer</h2>
            <p>
              The materials on Gedoba are provided on an 'as is' basis. We make no warranties,
              expressed or implied, and hereby disclaim and negate all other warranties.
            </p>
          </section>
        </div>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
};
